import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Spin } from 'antd';

import { RootState } from '../../modules';
import { deleteTaskAsync, getTaskListAsync } from '../../modules/tasks';
import TaskCreateDrawer from './TaskCreateDrawer';
import TaskDetailDrawer from './TaskDetailDrawer';
import TaskListComponent from '../../components/tasks/TaskListComponent';
import qs from 'qs';

interface TaskListContainerProps {
  enterpriseId: string;
  projectId: string;
}

function TaskListContainer({
  history,
  match,
}: RouteComponentProps<TaskListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [visibleCreateDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const [visibleDetailDrawer, setVisibleDetailDrawer] =
    useState<boolean>(false);
  const [detailDrawerConfig, setDetailDrawerConfig] = useState<any>();

  const { data, loading, error } = useSelector(
    (state: RootState) => state.tasks.tasks,
  );
  const user = useSelector((state: RootState) => state.auth.auth.data);

  const { taskId } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getTaskListAsync.request({
        enterpriseId,
        projectId,
      }),
    );
  }, [enterpriseId, projectId, dispatch]);

  useEffect(() => {
    if (taskId) {
      setDetailDrawerConfig({
        taskId: taskId,
      });
      setVisibleDetailDrawer(true);
    }
  }, [taskId]);

  const onCreate = () => {
    setVisibleCreateDrawer(true);
  };

  const onDetail = (_taskId: string) => {
    setDetailDrawerConfig({
      taskId: _taskId,
    });
    setVisibleDetailDrawer(true);
  };

  const onDelete = (_taskId: string) => {
    dispatch(
      deleteTaskAsync.request({
        enterpriseId,
        projectId,
        taskId: _taskId,
      }),
    );
  };

  const onCloseCreateDrawer = () => {
    setVisibleCreateDrawer(false);
  };

  return (
    <>
      {loading && <Spin />}
      {error && <Alert message={`${error}`} type="error" showIcon closable />}
      {/* {data && (
        <TaskCalendarComponent
          tasks={data}
          moveToCreatePage={onCreate}
          moveToDetailPage={onDetail}
          onDelete={onDelete}
          onSelect={onSelect}
        />
      )} */}
      {data && user && (
        <TaskListComponent
          tasks={data}
          user={user}
          moveToCreatePage={onCreate}
          moveToDetailPage={onDetail}
          onDelete={onDelete}
        />
      )}
      <TaskCreateDrawer
        enterpriseId={enterpriseId}
        projectId={projectId}
        visible={visibleCreateDrawer}
        onClose={onCloseCreateDrawer}
      />
      {detailDrawerConfig && (
        <TaskDetailDrawer
          enterpriseId={enterpriseId}
          projectId={projectId}
          taskId={detailDrawerConfig.taskId}
          visibleDetailDrawer={visibleDetailDrawer}
          onClose={() => {
            setVisibleDetailDrawer(false);
          }}
        />
      )}
    </>
  );
}

export default TaskListContainer;
